export const ASSIGNMENT_SUBMISSION_BASE_PATH = 'assignment-submission';
export const LECTURE_BASE_PATH = 'lecture';
export const COACH_ITEM_SHARED_ITEM_TYPENAME = 'coach';
export const COACH_ITEM_SHARED_ITEM_LABEL = 'COACH';
